import DOMPurify from "dompurify";

export function sanitizeHtml(html) {
  if (typeof html !== "string") return "";
  return DOMPurify.sanitize(html, {
    FORBID_TAGS: ["iframe", "object", "embed", "form", "input", "script"],
    FORBID_ATTR: ["onerror", "onclick", "onload", "onmouseover", "onfocus", "onblur"],
  });
}

const SAFE_URL_PROTOCOLS = /^(https?:|mailto:|tel:|#|\/)/i;

export function sanitizeUrl(url) {
  if (typeof url !== "string") return "";
  const trimmed = url.trim();
  if (trimmed === "") return "";
  if (SAFE_URL_PROTOCOLS.test(trimmed)) return trimmed;
  return "";
}

const SAFE_CSS_VALUE = /^\s*(\d+(\.\d+)?\s*(px|%|em|rem|vh|vw|ch|ex|vmin|vmax|pt|cm|mm|in)?|auto|inherit|initial|unset)\s*$/i;

export function sanitizeCssValue(value, fallback) {
  if (typeof value !== "string") return fallback;
  if (SAFE_CSS_VALUE.test(value.trim())) return value.trim();
  return fallback;
}
